import { render, staticRenderFns } from "./TermsUpdatedForm.vue?vue&type=template&id=14068be5&scoped=true"
import script from "./TermsUpdatedForm.vue?vue&type=script&lang=js"
export * from "./TermsUpdatedForm.vue?vue&type=script&lang=js"
import style0 from "./TermsUpdatedForm.vue?vue&type=style&index=0&id=14068be5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14068be5",
  null
  
)

export default component.exports